// Imports
import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import Cookies from "universal-cookie";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios"

// Constants
import { no_Numbers, mobile_number, no_special_characters, alphabet_Check } from "../../../constants/registration";
import * as Constants from "../../../constants/registration";
import { RoundCheckbox, errorMessage, PassportRadio, updateProfilePrefillFields } from "../../../constants/registration";
import updateProfileData from "../updateProfileData.json";
// Actions
import {
  getEducationLevelField, getInterestedInField,
  getCourseJoinPreferenceField, getTertiaryCheckboxData,
  getSecondaryDomainData, getAreaOfInterestField,
  getTargetedCountriesField
} from "../../../../store/slices/Registration/SignUpSlices";
import {
  createCurrentUrl, placeholderData, getCurrentMonth, getAbsoluteDestinationUrl,
  certificationPage, IdsCheck, deviceType, convertToTitleCase
} from "../../../utils/registrationUtils";
import { gaEvent, gaLocationAndContentData } from "../../../utils/index";
import * as actionTypes from "../../../../store/slices/Registration/SignUpSlices"
import { postUpdateProfile, getUserInfo, getUserIp, getGeolocationData, getUserAuthentication, postUserLoginSignupOtp } from "../../../../store/slices/Registration/CommonSlices";
import { postOtpVerifyCheck } from "../../../../store/slices/Registration/GoogleSignInSlice";

// Components
import CareersRegisterControl from "../CareersRegisterControl";
import CareersRegisterSecondaryInterest from "../CareersRegisterSecondaryDomain";
import CareersRegisterRadio from "../CareersRegisterRadio";

const CareersRegisterUpdateProfile = (props) => {
  // -------------Local states--------------
  const [radioBtn, setRadioBtn] = useState([]);
  const [interestedInCheckbox, setInterestedInCheckbox] = useState([]);
  const [formikValues, setFormikValues] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [tertiaryData, setTertiaryData] = useState([]);
  const [secondaryInterestCheckbox, setSecondaryInterestCheckbox] = useState([]);
  const [reinitialize, setReinitialize] = useState(true)
  const [isActive, setIsActive] = useState(true);
  const [syncSignupValues, setSyncSignupValues] = useState({});
  const [currentFields, setCurrentFields] = useState(0);
  const [prevEducationLevelMap, setPrevEducationLevelMap] = useState({})
  const [remainingSeconds, setRemainingSeconds] = useState(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0));

  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  const { otpVerifyCheck, otpVerifyLoading, otpVerifyError } = useSelector((state) => state.usersGoogleSiginIn)
  let submitButtonEnable = Object.keys(fieldErrors).length === 0 && (!props.updateProfileLoading || props.updateProfileError) && (props.updateProfileData?.required_field?.includes("mobile") ? otpVerifyCheck : true);

  // Initialize cookies and navigate objects
  const cookies = new Cookies();
  let date = new Date();
  const navigate = useNavigate();
  const [formCurrentState, setFormCurrentState] = useState(cookies.get("loginState") ?? null);

  // Check current URL and set source destination
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify"];
  const currentDeferrerUrl = document.referrer
  const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
  const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
  // const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const oneClickData = cookies.get("one-click-login")?.data?.mobile;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  //---------------------------------------  
  let searchParams = window.location.search;
  // Get URL parameters
  const oneClickLocation = new URLSearchParams(searchParams)?.get("check_url");

  //Get prefered education stream level from cookies
  const preferredLevelStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefferred_level_streams;
  // const preferredStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.preffered_streams;
  // const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/login/otp-verify"];
  // const isMatch = urls.some(path => currentUrl?.includes(path));
  // Handle beforeunload event to prevent page refresh if certain conditions are met
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Cancel the event to prevent the page from refreshing immediately
      event.preventDefault();
    };
    if (currentFields > 1 && props.reloadFlagOnExit && props.reloadFlagDestination) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    return (() => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    })
  }, [currentFields, props.reloadFlagOnExit, props.reloadFlagDestination])


  // Monitor user activity to reset timeout and determine inactivity
  useEffect(() => {
    let timeout;

    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setIsActive(false), 900000); // 15 minutes in milliseconds
    };

    const handleActivity = () => {
      setIsActive(true);
      resetTimeout();
    };

    const addEventListeners = () => {
      if (deviceType === "web") {
        window.addEventListener('click', handleActivity);
        window.addEventListener('keydown', handleActivity);
      } else {
        window.addEventListener('scroll', handleActivity);
        window.addEventListener('click', handleActivity);
        window.addEventListener('touchstart', handleActivity);
        window.addEventListener('touchmove', handleActivity);
        window.addEventListener('keydown', handleActivity);
      }
    };

    addEventListeners();
    resetTimeout();

    return () => {
      if (deviceType === "web") {
        window.removeEventListener('click', handleActivity);
        window.removeEventListener('keydown', handleActivity);
      } else {
        window.removeEventListener('scroll', handleActivity);
        window.removeEventListener('click', handleActivity);
        window.removeEventListener('touchstart', handleActivity);
        window.removeEventListener('touchmove', handleActivity);
        window.removeEventListener('keydown', handleActivity);
      }

      clearTimeout(timeout);
    };
  }, [currentFields]);

  // Redirect user to login page if inactive and no user data present
  useEffect(() => {
    if (!isActive && !props.user) {
      navigate(`/user/login${window.location.search}`)
      cookies.remove("loginState", {
        path: "/",
        domain: destinationDomain,
      });
      cookies.remove(`${subDomainName}-${certificationFormCheck}-updateProfile`, {
        path: "/",
        domain: destinationDomain,
      });
    }
  }, [isActive])

  // Initialize API calls and reinitialization state
  useEffect(() => {
    sessionStorage.removeItem("up_domain_id");
    setTimeout(() => setReinitialize(false), 500);
    CallingOnLOadApiActions();

    // Handle user data loading and update cookies accordingly
    if (props.user) {
      let params = {}
      params.user_id = cookies.get("loginState")?.user_id || props.user?.id;
      params.current_url = window.location.href;
      params.page_url = sourseDestination;
      params.certification = props.domain?.id == 2 ? true : false;
      props.dispatch(getUserInfo(params))
      postUpdateProfileDataOnLoad(props.user)
    }
  }, [props.user]);


  // Fetch geolocation data based on user IP
  useEffect(() => {
    if (props.userIps || props.userIpError) {
      props.dispatch(getGeolocationData({ ip: props.userIps?.ip }))
    }
  }, [props.userIps || props.userIpError])

  // Prefill form fields based on user data and required fields
  useEffect(() => {
    const eduInterest = props.updateProfileData?.required_field?.includes("education_interest") ? !formikValues?.education_interest : false;
    const cerInterest = props.updateProfileData?.required_field?.includes("certificate_interest") ? !formikValues?.certificate_interest : false;
    const interestValues = props.domain?.id == 2 ? (eduInterest || cerInterest) : true;
    if (props.updateProfileData && props.userDetails && !props.updateProfileData?.required_field?.includes("education_level")
      && !props.updateProfileData?.required_field?.includes("secondary_interest") && interestValues) {
      let prefillFieldsName = props.updateProfileData?.required_field?.filter((item) => {
        if (updateProfilePrefillFields?.includes(item)) {
          return item;
        }
      }
      )
      let interestedInCheck = false;
      if (props.domain.id == 2 && !props.updateProfileData?.required_field?.includes("interested_in")) {
        interestedInCheck = true;
      }

      if (prefillFieldsName?.length > 0 || interestedInCheck) {
        setFormikValues((prev) => {
          let updatedFormikValues = { ...prev };
          prefillFieldsName?.filter((fieldName) => {
            if (props.userDetails[fieldName]?.length > 0 || interestedInCheck) {
              if (fieldName === "area_of_interest" || fieldName === "country") {
                updatedFormikValues = {
                  ...updatedFormikValues,
                  [fieldName]: props.userDetails[fieldName]
                };
              } else if (props.domain.id == 2 && fieldName === "interested_in" & props.userDetails?.interested_in?.length > 0 && props.updateProfileData?.required_field?.includes("interested_in")) {
                let updatedCheckBoxes = props.dropdownData?.interested_in?.values?.filter((obj, ind) => {
                  if ([1, 2].includes(obj.preference_id)) {
                    return obj
                  }
                })
                updatedFormikValues = {
                  ...updatedFormikValues,
                  "interested_in": updatedCheckBoxes
                };
              } else if (interestedInCheck) {
                updatedFormikValues = {
                  ...updatedFormikValues,
                  "interested_in": props.userDetails?.interested_in
                };
              }
              else {
                updatedFormikValues = {
                  ...updatedFormikValues,
                  [fieldName]: props.userDetails[fieldName]?.[0]
                };
              }
            }
          });
          return updatedFormikValues;
        });
        setReinitialize(true)
        setTimeout(() => setReinitialize(false), 50);
      }
    }
  }, [props.updateProfileData, props.userDetails])

  // Set login state cookie based on form state
  useEffect(() => {
    if (formCurrentState && !props.updateProfileData?.cookies) {
      cookies.set("loginState", formCurrentState, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 3)),
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
      });
    }
  }, [formCurrentState]);

  // Checks if formikValues contain certain fields and dispatches an action to get tertiary checkbox data
  useEffect(() => {
    if (formikValues?.education_level || formikValues?.location
      || (formikValues?.education_interest || formikValues?.aspiring_stream || formikValues?.target_year)) {
      let params = {};
      params.url = sourseDestination;
      params.state_id = formikValues?.location?.state_id;
      params.level_id = formikValues?.education_level?.id;
      params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || props.user?.id);
      if (formikValues?.education_interest)
        params.education_stream = formikValues?.education_interest.domain_id;;
      if (formikValues?.aspiring_stream)
        params.aspiring_stream = formikValues?.aspiring_stream?.id
      if (formikValues?.target_year)
        params.target_year = formikValues?.target_year?.id
      if (formikValues?.passing_year)
        params.passing_year = formikValues?.passing_year?.id;
      props.dispatch(getTertiaryCheckboxData(params))
    }
  }, [formikValues?.education_level, formikValues?.location, formikValues?.education_interest, formikValues?.aspiring_stream, formikValues?.target_year])

  // Sets radio button values for course joining preference if certain conditions are met
  useEffect(() => {
    if (props.dropdownData?.course_joining_preference && props.domain?.id == 2) {
      setRadioBtn(props.dropdownData?.course_joining_preference?.values)
    }
  }, [props.dropdownData?.course_joining_preference])

  useEffect(() => { //data segragation for radio and checkboxes
    // handling prefilled data through cookies for checkboxes
    if (props.dropdownData?.interested_in?.values?.length > 0) {
      setInterestedInCheckbox(props.dropdownData?.interested_in?.values)
      if (props.domain.id == 2) {
        let updatedCheckBoxes = props.dropdownData?.interested_in?.values?.filter((obj, ind) => {
          if ([1, 2].includes(obj.preference_id)) {
            return obj
          }
        })
        setFormikValues((prev) => ({ ...prev, "interested_in": updatedCheckBoxes }))
        setReinitialize(true)
        setTimeout(() => setReinitialize(false), 500);
      }
    }
  }, [props.dropdownData?.interested_in])

  // Calls postUpdateProfileCertificationOnLoad if certain conditions are met
  useEffect(() => {
    if (props.domain?.id == 2 && interestedInCheckbox && props.updateProfileData?.required_field?.includes("interested_in")
      && !props.updateProfileData?.required_field?.includes("education_level")) {
      postUpdateProfileCertificationOnLoad(props.user);
    }
  }, [interestedInCheckbox && props.updateProfileData?.required_field?.includes("interested_in")])

  // Calls postUpdateProfileCertificationOnLoad if certain conditions are met
  useEffect(() => { //to call update profile api for 
    if (props.domain?.id == 2 && !props.updateProfileData?.required_field?.includes("education_level") &&
      (formikValues?.education_interest || formikValues?.certificate_interest) && props.userDetails) {
      postUpdateProfileCertificationOnLoad(props.user);
    }
  }, [(formikValues?.education_interest || formikValues?.certificate_interest) && props.userDetails])

  // Sets tertiary data if props.tertiaryCheckboxData is available
  useEffect(() => {
    if (props.tertiaryChecboxData) {
      setTertiaryData(RoundCheckbox)
    }
  }, [props.tertiaryChecboxData])

  // Validates form fields and sets reinitialization flag
  useEffect(() => {
    setFieldErrors(validate(formikValues))
    setReinitialize(true)
    setTimeout(() => setReinitialize(false), 500);

    // Calls postUpdateProfileSecondaryInterest if certain conditions are met
    if (props.updateProfileData?.required_field?.includes("secondary_interest")) {
      postUpdateProfileSecondaryInterest();
    }
    // Sets formik values for education level if certain conditions are met
    if (!props.updateProfileData?.required_field?.includes("education_level") && props.updateProfileData) {
      setFormikValues((prev) => ({ ...prev, "education_level": props.updateProfileData?.user_education_level }))
      setReinitialize(true)
      setTimeout(() => setReinitialize(false), 50);
    }
  }, [props.updateProfileData, props.userError])

  // Sets secondary interest checkboxes if available
  useEffect(() => {
    if (props.secondaryInterest?.values?.length > 0) {
      const updatedCheckboxes = props.secondaryInterest?.values?.filter((obj) => obj.selected)
      setSecondaryInterestCheckbox(updatedCheckboxes);
      setFormikValues((prev) => ({ ...prev, "secondary_interest": updatedCheckboxes }));
      setReinitialize(true)
      setTimeout(() => setReinitialize(false), 50);
    }
  }, [props.secondaryInterest])

  useEffect(() => {  //user auth check mobile
    if (formikValues?.mobile && !fieldErrors?.mobile) {
      let params = {};
      params.mobile_number = formikValues?.mobile
      props.dispatch(getUserAuthentication(params));
    }
  }, [formikValues?.mobile, fieldErrors?.mobile])

  // Calls necessary API actions on load
  const CallingOnLOadApiActions = () => {
    // for pages preferred level
    let preferedEducationLevel = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefered_education_level;
    props.dispatch(getUserIp());
    postUpdateProfileDataOnLoad();
    let params = {}
    params.user_id = cookies.get("loginState")?.user_id || props.user?.id;
    params.current_url = window.location.href;
    params.page_url = sourseDestination;
    params.certification = props.domain?.id == 2 ? true : false;
    if (!props.user) props.dispatch(getUserInfo(params))
    let paramLevel = { ...params }
    paramLevel.field = "education_level";
    if (preferedEducationLevel) {
      paramLevel.preferred_level = typeof preferedEducationLevel === 'object' ? Object.keys(preferedEducationLevel)?.[0] : preferedEducationLevel;
    }
    props.dispatch(getEducationLevelField(paramLevel));
    if (props.domain?.id == 2) props.dispatch(getCourseJoinPreferenceField({ ...params, field: "course_joining_preference" }));
    if (props.domain?.id != 1 && props.domain?.id != 5) props.dispatch(getInterestedInField({ ...params, field: "interested_in" }));
    if (props.domain.id == 3) setRadioBtn(PassportRadio);
    if (props.domain?.id == 3) props.dispatch(getTargetedCountriesField({ ...params, field: "country" }))
  }

  // Profile update API call for certification on load
  const postUpdateProfileCertificationOnLoad = (user, val = formikValues?.interested_in?.preference_id) => { //profile update api call if update profile case is true in login api and onload
    const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
    let params = {};
    params.current_url = window.location.href;
    params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
    params.destination = destinationUrl
    params.cta_clicked = oneClickLocation === "one_click" ? "one_click" : !!cookies.get("loginState")?.google_status ? "google" : "login";
    params.certification = props.domain?.id == 2 ? true : false;
    params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || user?.id);
    if (!!oneClickData) {
      params.mobile_verify = 1;
      params.mobile_number = oneClickData;
    }
    if (!!cookies.get("loginState")?.google_status) params.google_status = 1;
    if (props.domain?.id == 2 && props.updateProfileData?.required_field?.includes("interested_in")) {
      params.interested_in = IdsCheck(formikValues?.interested_in) || [1, 2];
    }
    if (props.domain?.id == 2 && formikValues?.education_interest
    ) {
      if (formikValues?.education_interest?.id) {
        params.degree_interested = formikValues?.education_interest?.id
      }
      if (formikValues?.education_interest?.is_group) {
        params.is_group = true;
      }
      params.domain_id = formikValues?.education_interest?.domain_id;
    }
    if (props.domain?.id == 2 && formikValues?.certificate_interest
    ) {
      params.certificate_interest = formikValues?.certificate_interest?.domain_id;
    }
    if (props.loginDatas?.user_id || cookies.get("loginState")?.user_id || user?.id)
      props.dispatch(postUpdateProfile(params));
    let obj = { ...params }
    if (props.domain?.id == 2 && props.updateProfileData?.required_field?.includes("interested_in")) {
      obj.interested_in = formikValues?.interested_in?.length > 0 ? `${IdsCheck(formikValues?.interested_in).join(',')}` : [1, 2]?.join(",");
    }
    obj.field = "area_of_interest";
    props.dispatch(getAreaOfInterestField(obj));
  }

  // Profile update API call on load
  const postUpdateProfileDataOnLoad = (user, val = formikValues?.interested_in?.preference_id) => { //profile update api call if update profile case is true in login api and onload
    const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
    let params = {};
    params.current_url = window.location.href;
    params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
    params.destination = destinationUrl
    params.cta_clicked = oneClickLocation === "one_click" ? "one_click" : !!cookies.get("loginState")?.google_status ? "google" : "login";
    params.certification = props.domain?.id == 2 ? true : false;
    params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || user?.id);
    if (!!oneClickData) {
      params.mobile_verify = 1;
      params.mobile_number = oneClickData;
    }
    if (!!cookies.get("loginState")?.google_status) params.google_status = 1;
    if (props.loginDatas?.user_id || cookies.get("loginState")?.user_id || user?.id)
      props.dispatch(postUpdateProfile(params));
  }

  // Profile update API call for secondary interest
  const postUpdateProfileSecondaryInterest = () => {
    const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
    let params = {};
    params.current_url = window.location.href;
    params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
    params.destination = destinationUrl
    params.cta_clicked = !!cookies.get("loginState")?.google_status ? "google" : "login";
    params.certification = props.domain?.id == 2 ? true : false;
    params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || props.user?.id);
    params.field = "secondary_interest";
    if (formikValues?.education_level) {
      params.education_level = formikValues?.education_level?.id;
    }
    params.domain_id = formikValues?.education_interest?.domain_id;
    params.degree_interested = formikValues?.education_interest?.id;
    if (formikValues?.education_interest?.is_group) { //to be changed 
      params.is_group = true;
    }
    props.dispatch(getSecondaryDomainData(params));
  }

  // Function to submitting update profile data
  const postUpdateProfileData = () => {
    const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
    let params = {};
    params.current_url = window.location.href;
    params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
    params.destination = destinationUrl
    params.cta_clicked = oneClickLocation === "one_click" ? "one_click" : !!cookies.get("loginState")?.google_status ? "google" : "login";
    params.certification = props.domain?.id == 2 ? true : false;
    params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || props.user?.id);
    params.checkbox_id = props.tertiaryChecboxData?.id ?? 0;
    params.checkbox_status = formikValues?.tertiary_checkbox?.[0]?.id == 1 ? true : false;
    params.submit = true;
    if (props.updateProfileData?.required_field?.length > 0) {
      props.updateProfileData?.required_field?.forEach(fieldName => {
        if (Array.isArray(formikValues[fieldName]) && fieldName != "interested_in" && fieldName != "passport"
          && fieldName != "course_joining_preference" && fieldName != "work_experience" && fieldName != "name") {
          if (fieldName == "area_of_interest") {
            params.area_of_interest = formikValues?.area_of_interest;
          }
          else {
            params[fieldName] = IdsCheck(formikValues[fieldName]);
          }
        } else if (formikValues?.education_interest && fieldName == "education_interest") {
          if (formikValues?.education_interest?.id) {
            console.log("degree_interested 1");
            console.log("fieldName 1", fieldName);
            params.degree_interested = formikValues?.education_interest?.id
          }
          if (formikValues?.education_interest?.group_id) {
            params.is_group = true;
          }
          params.domain_id = formikValues?.education_interest?.domain_id;
        }
        else if (formikValues?.certificate_interest && fieldName == "certificate_interest") {
          params.certificate_interest = formikValues?.certificate_interest?.domain_id;
        }
        else {
          params[fieldName] = formikValues[fieldName]?.id;
        }
      });
    }
    if (!!cookies.get("loginState")?.google_status) params.google_status = 1;
    if (props.updateProfileData?.required_field?.includes("name"))
      params.name = formikValues?.name?.trim();
    if (props.updateProfileData?.required_field?.includes("mobile")) {
      params.mobile_number = formikValues?.mobile;
      params.mobile_verify = 1;
    }
    if (props.updateProfileData?.required_field?.includes("interested_in"))
      params.interested_in = formikValues.interested_in?.length > 0 ? IdsCheck(formikValues?.interested_in) : [];
    if (props.updateProfileData?.required_field?.includes("passport"))
      params.passport = formikValues.passport?.[0]?.id;
    if (props.updateProfileData?.required_field?.includes("course_joining_preference"))
      params.course_joining_preference = formikValues?.course_joining_preference?.[0]?.id;
    if (props.updateProfileData?.required_field?.includes("work_experience"))
      params.work_experience = JSON.stringify(formikValues.work_experience?.id);
    if (props.secondaryInterest) {
      params.secondary_interest = formikValues.secondary_interest;
    }
    props.dispatch(postUpdateProfile(params));
  }
  // Function to validate form values
  const validate = (values) => {
    let errors = {};

    AllFieldsData(values)?.map((item, index) => {
      if (props.domain?.id == 2 && (!values.interested_in || values.interested_in?.length === 0)) {
        errors.interested_in = "Please select your interest."
      }
      //mobile
      if (item.alternate_name == "mobile") {
        if (!values.mobile) {
          errors.mobile = "Please enter your mobile number.";
        }
        else if (mobile_number.test(values.mobile)) {
          errors.mobile = "Invalid mobile. Must start with 6,7,8,9.";
        }
        else if (values.mobile?.length != 10) {
          errors.mobile = "Invalid mobile. Must have 10 digits.";
        }
        else if (no_special_characters.test(values.mobile)) {
          errors.mobile = "Invalid mobile. No special character accepted.";
        }
        else if (alphabet_Check.test(values.mobile)) {
          errors.mobile = "Invalid mobile. Aplhabets are not allowed.";
        }
      }
      let fieldName = convertToTitleCase(item.alternate_name);
      let labelMatched = errorMessage.find((error) => error.label === item.alternate_name);
      if (item.alternate_name != "interested_in" && item.alternate_name != "name" && (!values[item.alternate_name] || values[item.alternate_name].length == 0)) {
        if (item.alternate_name == "aspiring_stream" && (values.education_level?.id <= 10 || values.education_level <= 10)) {
          errors.aspiring_stream = "Please select interested subjects' stream."
        }
        else if (item.alternate_name == "aspiring_stream" && (values.education_level?.id > 10 || values.education_level > 10)) {
          errors.aspiring_stream = "Please select your current stream in school."
        }
        else if (item.alternate_name == "education_interest" && (values.education_level?.id <= 10 || values.education_level <= 10)) {
          errors.education_interest = "Please select your interested stream for college."
        }
        else if (item.alternate_name == "education_interest" && (values.education_level?.id >= 11 || values.education_level >= 11)) {
          errors.education_interest = "Please select course interest for college."
        }
        else if (item.alternate_name == "degree_pursue" && (((values?.education_level?.id >= 22 || values?.education_level >= 22) && (values?.education_level?.id <= 25 || values?.education_level <= 25))
          || (values?.education_level?.id > 28 || values?.education_level?.id > 28))) {
          errors.degree_pursue = "Please select your completed degree."
        } else {
          errors[item.alternate_name] = labelMatched ? labelMatched.message : `${fieldName} field is required.`
        };
      }
      if (item.alternate_name == "name") {
        if (!values.name && props.domain?.id == 1) {
          errors.name = "Please enter student's name.";
        }
        else if (!values.name && props.domain?.id != 1) {
          errors.name = "Please enter your name.";
        } else {
          if (no_Numbers.test(values.name.trim())) {
            errors.name = "Name should not contain numbers.";
          }
          if (no_special_characters.test(values.name.trim())) {
            errors.name = "Name should not contain special character.";
          }
          if (values.name.trim().length < 2 || values.name.trim().length > 60) {
            errors.name = "Invalid name. Please enter 2 to 60 characters.";
          }
        }
      }
    }
    );
    setFormCurrentState((prev) => ({ ...prev, errors }))
    return errors;

  };
  const AllFieldsData = (values, click) => {
    let fieldsCount = updateProfileData?.data
      ?.find((obj) => obj.domain == props.domain?.id)
      ?.fields?.filter((item, index) => {
        // Check if the user's education level matches the field's required education level
        let education_level_data = props.updateProfileData?.required_field?.includes("education_level") ? item.education_level?.includes(values?.education_level?.id)
          : item.education_level?.includes(props.updateProfileData?.user_education_level)

        // Check if the user is interested in the required fields
        let interestedInFields = Array.isArray(values?.interested_in) && values?.interested_in?.length > 0 && values.interested_in?.find((obj) =>
          item.interested_in?.includes(obj.preference_id))

        // Determine if the field should be displayed based on dependencies
        let isTotalFields = item.dependency_type == "AND" ? education_level_data && item.interested_in?.includes(interestedInFields?.preference_id) : education_level_data
        if (item.name == "area_of_interest" && !(values?.certificate_interest || values?.education_interest)) {
          isTotalFields = false
        }
        // Always render certain fields based on conditions
        if (props.updateProfileData?.required_field?.includes("education_level") && (item.alternate_name == "education_level" || item?.defaultRender)) {
          isTotalFields = true;
        }
        // Determine if the field should be rendered
        let renderField = false
        if (item.alternate_name == "passing_year") {
          if (["March", "April"]?.includes(getCurrentMonth()) || values?.education_level?.id == 13) {
            renderField = true
          }
        } else {
          renderField = true
        }
        let mobileField = false;
        if (item.alternate_name == "mobile" && (props.updateProfileData?.required_field?.includes("mobile") || otpVerifyCheck)) {
          mobileField = true;
        }
        // Render the field if conditions are met
        if ((item.alternate_name == "mobile" ? mobileField : props.updateProfileData?.required_field?.includes(item.alternate_name))
          && !props.updateProfileData?.required_field?.includes("secondary_interest") && renderField && isTotalFields) {
          return item;
        }
      })

    if (click == "GA") gaEvent("signinupdateprofilesubmit", "login_signup", `${gaLocationAndContentData}`, `${fieldsCount?.length}`);
    return fieldsCount;
  }


  // Function to update touched fields state
  const updateTouchedFields = (touched) => {
    // just for error handling purpose
  }
  return (
    <>
      <div className="careers_register_tab">
        {props.updateProfileData?.form_label && <>
          <h5><b>{props.updateProfileData?.form_label}</b></h5>
          <div className="update_profile_description">Help us provide better recommendations by sharing your updated preferences!</div>
        </>}

        <div>
          <Formik
            initialValues={formikValues}
            enableReinitialize={reinitialize}
            // validationSchema={schema}
            validate={validate}
            validateOnChange={validate}
            onSubmit={(values, { setSubmitting }) => {
              const errors = validate(values);
              setFieldErrors(errors);
            }}
            initialErrors={fieldErrors}
          >
            {({
              formik,
              values,
              handleChange,
              setFieldValue,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              setErrors,
              setTouched
            }) => {
              useEffect(() => {
                setFormikValues(values);
                setFormCurrentState((prev) => ({ ...prev, formValuesUpdateProfile: values }))
                const errors = validate(values);
                setFieldErrors(errors);
                setErrors(errors);
                countCurrentFields()
              }, [values]);

              // Function to count current fields
              const countCurrentFields = () => {
                const requiredFieldsData = props.updateProfileData?.required_field
                let count = 0
                for (const key in values) {
                  const requiredFieldChecks = props.updateProfileData?.required_field?.includes("education_level") ? true : requiredFieldsData?.includes(key);
                  if (values.hasOwnProperty(key) && values[key] !== null && requiredFieldChecks) {
                    count = count + 1
                    setCurrentFields(count);
                  }
                }
              }
              // send otp api call 
              const SendOtpOnMobile = () => {
                if (props.usersAuthentication) {
                  let params = {};
                  params.otp_on = "mobile";
                  params.cta_clicked = "google";
                  params.otp_action = "send";
                  params.isd_code = "+91";
                  params.mobile_number = formikValues?.mobile;
                  props.dispatch(postUserLoginSignupOtp(params));
                }
              }

              // Function to handle checkbox changes for "interested" items
              const handleInterestedCheckbox = (item, id) => { //checkbox
                const updatedCheckboxes = interestedInCheckbox?.map((checkbox) =>
                  checkbox.preference_id === id
                    ? { ...checkbox, selected: !checkbox.selected }
                    : checkbox
                );
                setInterestedInCheckbox(updatedCheckboxes);
                setFieldValue(
                  item?.alternate_name,
                  updatedCheckboxes?.filter((obj) => obj.selected)
                );
              };

              // Function to handle checkbox changes for secondary domain
              const handleSecondaryDomainCheckbox = (item, id) => {
                const updatedCheckboxes = secondaryInterestCheckbox?.length > 0 && secondaryInterestCheckbox?.map((checkbox) =>
                  `int_${checkbox.degree_id}_${checkbox.stream_id}` == id
                    ? { ...checkbox, selected: !checkbox.selected }
                    : checkbox
                );
                setSecondaryInterestCheckbox(updatedCheckboxes);

                // Create a new array with all objects, setting unselected items as `selected: false`
                const allCheckboxesWithExplicitSelected = updatedCheckboxes?.map((checkbox) =>
                  checkbox.selected
                    ? { ...checkbox, selected: true }
                    : { ...checkbox, selected: false }
                );
                setFieldValue(
                  "secondary_interest",
                  allCheckboxesWithExplicitSelected
                );

              };
              // Function to handle radio button changes  
              const handleRadioChange = (item, id) => {
                const updatedCheckboxes = radioBtn?.map((checkbox) => ({
                  ...checkbox,
                  selected: checkbox.id === id,
                }));
                setRadioBtn(updatedCheckboxes);
                setFieldValue(
                  item?.alternate_name,
                  updatedCheckboxes?.filter((obj) => obj.selected)
                );

              };
              // Function to handle tertiary checkbox changes
              const handleTertiaryChange = (item, id) => {
                const tertiaryRadio = tertiaryData?.map((checkbox) => ({
                  ...checkbox,
                  selected: checkbox.id === id,
                }));
                setTertiaryData(tertiaryRadio)
                setFieldValue(
                  "tertiary_checkbox",
                  tertiaryRadio?.filter((obj) => obj.selected)
                );
              }
              const handleOtpVerify = () => {
                let obj = {};
                obj.cta_clicked = "google";
                obj.isd_code = "+91";
                obj.mobile_number = values.mobile;
                obj.otp_on = "mobile";
                if (!!formCurrentState?.google_status) {
                  obj.google_status = 1;
                }
                obj.otp = values.otp;
                if (formCurrentState?.user_id || props.user?.id) {
                  obj.user_id = formCurrentState?.user_id || props.user?.id;
                }
                if (!!formCurrentState?.u_info) {
                  obj.u_info = formCurrentState?.u_info;
                }
                props.dispatch(postOtpVerifyCheck(obj));
              }

              // Function to post profile update on change
              const postUpdateProfileOnChange = (option, val = values?.interested_in, interest, certificateId, isLevel) => {
                const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
                let params = {};
                params.current_url = window.location.href;
                params.page_url = !isMatch ? sourseDestination : getAbsoluteDestinationUrl();
                params.destination = destinationUrl
                params.cta_clicked = oneClickLocation === "one_click" ? "one_click" : !!cookies.get("loginState")?.google_status ? "google" : "login";
                params.certification = props.domain?.id == 2 ? true : false;
                params.user_id = props.loginDatas?.user_id ?? (cookies.get("loginState")?.user_id || props.user?.id);
                if (!!oneClickData) {
                  params.mobile_verify = 1;
                  params.mobile_number = oneClickData;
                }
                if (!!cookies.get("loginState")?.google_status) params.google_status = 1;
                if (props.updateProfileData?.required_field?.length > 0) {
                  // if ((["March", "April"]?.includes(getCurrentMonth()) || (option?.id > 8 || values?.education_level?.id > 8))) { // to stop redirecting to destination as requird field will be empty after selecting 6 to 8 level
                  params.education_level = option?.id || values?.education_level?.id;
                  // }
                  // if(option?.id>5 || option?.id<9){
                  //   params.education_level = option?.id || values?.education_level?.id;
                  // }
                  if (props.updateProfileData?.required_field?.includes("education_level") || props.updateProfileData?.required_field?.includes("interested_in")) {
                    params.interested_in = val?.[0]?.preference_id ? IdsCheck(val) : val ? val : [];
                  }
                  if (props.updateProfileData?.required_field?.includes("education_level") ? !isLevel : true) {
                    if (props.domain?.id == 2 && (values?.education_interest || interest)
                      && props.updateProfileData?.required_field?.includes("interested_in")
                      ? (val?.includes(1) || (IdsCheck(val)?.length > 0 ? IdsCheck(val)?.includes(1) : false)) : true) {
                      if (values?.education_interest?.id || interest?.id) {
                        console.log("degree_interested 2",);
                        console.log("interest?.id=>",interest?.id);
                                                console.log("interest?.id=>",interest?.id);
                        console.log(" values?.education_interest?.id", values?.education_interest?.id);
                        console.log("isLevel", isLevel);

                        //params.degree_interested = interest?.id || values?.education_interest?.id
                      }
                      if (values?.education_interest?.group_id || interest?.group_id) {
                        params.is_group = true;
                      }
                      params.domain_id = interest?.domain_id || values?.education_interest?.domain_id;
                    }
                    if (props.domain?.id == 2 && (values?.certificate_interest || certificateId)
                      && props.updateProfileData?.required_field?.includes("interested_in")
                      ? (val?.includes(2) || (IdsCheck(val)?.length > 0 ? IdsCheck(val)?.includes(2) : false)) : true) {
                      params.certificate_interest = values?.certificate_interest?.domain_id || certificateId;
                    }
                  }
                }
                props.dispatch(postUpdateProfile(params));
              }

              // Function to handle focus event
              const handleOnFocus = (event, name, item) => {
                if (
                  (name === "target_year" ||
                    (props.updateProfileData?.required_field?.includes("education_level")
                      ? values?.education_level?.id !== prevEducationLevelMap?.[name]
                      : true))
                ) {
                  setPrevEducationLevelMap((prev) => ({
                    ...prev,
                    [name]: values?.education_level?.id
                  }))
                  let params = {};
                  params.current_url = window.location.href;
                  params.page_url = sourseDestination;
                  params.field = name;
                  params.user_id = cookies.get("loginState")?.user_id || props.user?.id;
                  params.certification = props.domain?.id == 2 ? "True" : "False";
                  if (values?.education_level?.id)
                    params.education_level = values?.education_level?.id;
                  if (values?.passing_year?.id)
                    params.passing_year = values?.passing_year?.id;
                  if (values?.aspiring_stream)
                    params.aspiring_stream = values?.aspiring_stream?.id;
                  if (values?.education_interest) {
                    if (values?.education_interest?.id)
                      console.log("degree_interested 3");
                      params.degree_interested = values?.education_interest?.id
                    if (values?.education_interest?.group_id) {
                      params.is_group = true;
                    }
                    params.domain_id = values?.education_interest?.domain_id;
                  };

                  if (Array.isArray(values.interested_in) && values.interested_in?.length > 0)
                    params.interested_in = `${IdsCheck(values?.interested_in).join(',')}`;
                  if (values?.degree_pursue)
                    params.degree_pursue = values.degree_pursue?.id;
                  if (values.certificate_interest)
                    params.certificate_interest = values.certificate_interest?.domain_id;
                  if (name === "education_interest" && preferredLevelStreamData?.length > 0) {
                    params.preferred_stream_level = JSON.stringify(preferredLevelStreamData);
                    // if (preferredStreamData?.length > 0) params.preferredStreamData = JSON.stringify(preferredStreamData);
                  }
                  // Dispatch actions based on conditions
                  if (actionTypes[item.actionName] && (name === "education_interest"
                    || name === "certificate_interest"
                    || name === "target_year" || name === "aspiring_stream"
                    || name === "degree_pursue" || name === "passing_year")) {
                    props.dispatch(actionTypes[item.actionName](params));
                  } else if (actionTypes[item.actionName] && !props.dropdownData[name] && name !== "area_of_interest") {
                    props.dispatch(actionTypes[item.actionName](params));
                  };
                }
              }

              // Function to call area of interest API
              const areaOfInterestApiCall = (level = values?.education_level, interest = values.interested_in,
                eduInterest = values?.education_interest, cerInterest = values?.certificate_interest) => {
                const certificateInterestCheck = props.updateProfileData?.required_field?.includes("interested_in") ? (interest?.includes(2)
                  || (IdsCheck(interest)?.length > 0 ? IdsCheck(interest)?.includes(2) : false)) : true;
                const educationInterestCheck = props.updateProfileData?.required_field?.includes("interested_in") ? (interest?.includes(1)
                  || (IdsCheck(interest)?.length > 0 ? IdsCheck(interest)?.includes(1) : false)) : true;
                let params = {};
                updateTouchedFields({ ...touched, ["area_of_interest"]: true })
                params.current_url = window.location.href;
                params.page_url = sourseDestination;
                params.field = "area_of_interest";
                params.certification = props.domain?.id == 2 ? "True" : "False";
                params.user_id = cookies.get("loginState")?.user_id || props.user?.id;
                // Additional params based on conditions
                console.log("degree_interested 4",eduInterest);
                if (level?.id)
                  params.education_level = level?.id;
                if (eduInterest && educationInterestCheck) {
                  if (eduInterest?.id)
                    params.degree_interested = eduInterest?.id
                  if (eduInterest?.group_id) {
                    params.is_group = true;
                  }
                  params.domain_id = eduInterest?.domain_id;
                };

                if (interest?.length > 0 && (props.updateProfileData?.required_field?.includes("education_level")
                  || props.updateProfileData?.required_field?.includes("interested_in")))
                  params.interested_in = interest?.[0]?.preference_id ? `${IdsCheck(interest)?.join(',')}` : interest?.length > 0 ? interest?.join(',') : [];
                if (cerInterest && certificateInterestCheck) {
                  params.certificate_interest = cerInterest?.domain_id;
                }
                props.dispatch(getAreaOfInterestField(params))
              }

              // Render the form
              return (
                <Form onSubmit={handleSubmit}>
                  <div>
                    {/* Fields to render based on certain condition */}
                    <Row className="update_profile_form_fields">
                      {AllFieldsData(values)?.map((item, index) => {
                        return (
                          <Col
                            md={
                              item.fieldType == "checkbox" ||
                                item.fieldType == "radio"
                                ? "12"
                                : "6"
                            }
                          >
                            <CareersRegisterControl
                              item={item}
                              label={item?.label}
                              control={item?.fieldType}
                              name={item?.alternate_name}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              values={values}
                              errors={errors}
                              fieldErrors={fieldErrors}
                              touched={touched}
                              constants={Constants[item?.options]}
                              fieldSelectType={item?.fieldSelectType}
                              placeholder={placeholderData(item, values, props.domain)}
                              maxLimit={item?.maxLimit}
                              handleBlur={handleBlur}
                              dropdownData={props.dropdownData[item.alternate_name]}
                              domain={props.domain}
                              interestedInCheckbox={interestedInCheckbox}
                              setInterestedInCheckbox={setInterestedInCheckbox}
                              handleInterestedCheckbox={(e, id) =>
                                handleInterestedCheckbox(item, id)
                              }
                              radioBtn={radioBtn}
                              handleRadioChange={(e, id) => handleRadioChange(item, id)}
                              handleOnFocus={(event) => handleOnFocus(event, item.alternate_name, item)}
                              searchBar={item.searchBar}
                              geolocationData={props.geolocationData}
                              updateTouchedFields={updateTouchedFields}
                              setTouched={setTouched}
                              postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
                              setFormikValues={setFormikValues}
                              setReinitialize={setReinitialize}
                              isUpdateProfile={true}
                              setSyncSignupValues={setSyncSignupValues}
                              areaOfInterestApiCall={(level, interest, eduInterest, cerInterest) => areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
                              SendOtpOnMobile={() => SendOtpOnMobile()}
                              handleOtpVerify={() => handleOtpVerify()}
                              setFormCurrentState={setFormCurrentState}
                              formCurrentState={formCurrentState}
                              setRemainingSeconds={setRemainingSeconds}
                              remainingSeconds={remainingSeconds}
                            />
                          </Col>
                        );
                      }
                      )}

                      {/* Render secondary interest fields if conditions are met */}
                      {props.secondaryInterest?.values?.length > 0 &&
                        props.updateProfileData?.required_field?.includes("secondary_interest") &&
                        <CareersRegisterSecondaryInterest
                          values={values}
                          errors={errors}
                          touched={touched}
                          secondaryInterest={props.secondaryInterest}
                          handleSecondaryDomainCheckbox={(name, id) => handleSecondaryDomainCheckbox("secondary_interest", id)}
                          secondaryInterestCheckbox={secondaryInterestCheckbox}
                        />}

                      {/* Render tertiary checkbox fields if conditions are met */}
                      {props.tertiaryChecboxData?.id && Object.keys(errors).length === 0 &&
                        props.updateProfileData?.required_field?.length > 0 &&
                        !props.updateProfileData?.required_field?.includes("secondary_interest") &&
                        <CareersRegisterRadio
                          name={"tertiary_checkbox"}
                          setFieldValue={setFieldValue}
                          values={values}
                          errors={errors}
                          touched={touched}
                          constants={props.constants}
                          radioBtn={tertiaryData}
                          handleRadioChange={(item, id) =>
                            handleTertiaryChange(item, id)
                          }
                          tertiaryChecboxData={props.tertiaryChecboxData}
                        />}
                    </Row>

                    {/* Render submit button */}
                    {props.updateProfileData?.required_field?.length > 0 &&
                      <div>
                        <button
                          type="submit"
                          disabled={submitButtonEnable ? false : true}
                          className={submitButtonEnable ?
                            "careers_register_valid_button careers_register_button"
                            : "careers_register_button"}
                          onClick={() => {
                            postUpdateProfileData(); AllFieldsData(values, "GA");
                            if (Object.keys(errors).length === 0 && !props.updateProfileError) {
                              sessionStorage.setItem(`${subDomainName}-${certificationFormCheck}-updateProfile`, JSON.stringify(true));
                            }
                          }}
                        >
                          Submit
                        </button>
                      </div>}
                  </div>

                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    dropdownData: state.userSignUpFields,
    usersAuthentication: state.usersCommonData?.userAuthentication,
    usersAuthenticationError: state.usersCommonData?.userAuthenticationError,
    userIps: state.usersCommonData?.userIp,
    geolocationData: state.usersCommonData?.geoLocation,
    postSignupData: state.userSignUpFields?.signupData,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
    loginDatas: state.usersCommonData?.loginData,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    tertiaryChecboxData: state.userSignUpFields?.tertiaryChecbox,
    updateProfileData: state.usersCommonData?.updateProfile,
    updateProfileError: state.usersCommonData?.updateProfileError,
    updateProfileLoading: state.usersCommonData?.updateProfileLoading,
    secondaryInterest: state.userSignUpFields?.secondaryDomain,
    user: state.userData?.user?.data,
    userError: state.userData?.user_error,
    userDetails: state.usersCommonData?.userInfo
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterUpdateProfile);